import React from "react";
import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../assets/Images/Vector.png";
import crossIconImg from "../assets/Images/crossIcon.png";
import "../App.css";

const PageHeader = ({ title, crossIcon }) => {
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        style={{
          padding: "20px",
          // borderBottom: "1px solid #EEEBEF",
        }}
      >
        <Link to="/" style={{ width: "45%" }}>
          <Stack direction="row" alignItems="center">
            <img src={Logo} style={{ width: "50px", height: "33px" }} />
            <span
              className="default-color"
              style={{
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              Amannat
            </span>
          </Stack>
        </Link>
        <Typography variant="h5" width="45%" style={{ fontWeight: "600" }}>
          {title}
        </Typography>
        {crossIcon ? (
          <Link to="/">
            <img
              src={crossIconImg}
              alt="cross Icon"
              style={{ height: "40px", width: "40px" }}
            />
          </Link>
        ) : (
          <></>
        )}
      </Stack>
      <div className="footer-line" style={{ marginBottom: "20px" }}></div>
    </>
  );
};

export default PageHeader;
